import { useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";

// Solo se muestra a administradores. El servidor vuelve a verificar el permiso.
export default function DirectorioBtn({ mes, fechaCorte }) {
  const [cargando, setCargando] = useState(false);
  const generar = async () => {
    setCargando(true);
    try {
      const r = await api.get("/informe-directorio.pdf", {
        params: { mes, fecha_corte: fechaCorte }, responseType: "blob", timeout: 120000,
      });
      const url = URL.createObjectURL(new Blob([r.data], { type: "application/pdf" }));
      const a = document.createElement("a");
      a.href = url;
      a.download = `Informe_Directorio_${mes}.pdf`;
      a.click();
      setTimeout(() => URL.revokeObjectURL(url), 60000);
      toast.success("Informe para directorio generado");
    } catch (e) {
      let msg = "No se pudo generar el informe para directorio";
      try {
        const t = await e?.response?.data?.text?.();
        if (t) msg = JSON.parse(t).detail || msg;
      } catch (_) { /* respuesta sin detalle */ }
      toast.error(msg);
    } finally {
      setCargando(false);
    }
  };
  return (
    <div className="flex flex-wrap items-center justify-between gap-3 rounded-xl border border-emerald-200 bg-emerald-50/60 px-4 py-3">
      <div>
        <div className="font-heading font-bold text-emerald-950 text-sm">Informe resumido para el directorio</div>
        <div className="text-xs text-slate-600">3 páginas · valores del panel · judicial según el cruce de Casos judiciales · solo administradores</div>
      </div>
      <button onClick={generar} disabled={cargando} data-testid="btn-informe-directorio"
        className="bg-emerald-700 hover:bg-emerald-800 disabled:opacity-60 text-white text-sm font-semibold px-4 py-2 rounded-md">
        {cargando ? "Generando…" : "Generar PDF para directorio"}
      </button>
    </div>
  );
}
